import {Dispatch} from "redux"
import {connect} from "react-redux"

// Models
import {RootState} from "../../../models"
import {DoctorStatsStateType} from "../models"

// Actions
import * as a from "../store/actions"

// Selectors
import {selectInProgressRecord, selectInProgressRecordFetching} from "../store/selectors"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    inProgressRecordFetching: selectInProgressRecordFetching(state),
    inProgressRecord: selectInProgressRecord(state),
});

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchInProgressRecord: () => dispatch(a.fetchInProgressRecordAsync.request()),
});

export type WithInProgressRecordProps = {
    inProgressRecordFetching: DoctorStatsStateType["inProgressRecordFetching"]
    inProgressRecord: DoctorStatsStateType["inProgressRecord"]
    fetchInProgressRecord(): void
}

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) => connect(mapStateToProps, mapDispatchToProps)(BaseComponent)
